import { render, staticRenderFns } from "./redirectUrlMonthly.vue?vue&type=template&id=a99bc166&scoped=true&"
import script from "./redirectUrlMonthly.vue?vue&type=script&lang=js&"
export * from "./redirectUrlMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99bc166",
  null
  
)

export default component.exports